/*
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpModule } from "@angular/http";
import { LinkyModule } from "ngx-linky";
import { NgxSpinnerModule } from "ngx-spinner";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { CustomTranslateLoader } from "./service/custom.translate.loader";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SurveyImageComponent } from "./survey-image/survey-image.component";
import { SurveyButtonComponent } from "./survey-button/survey-button.component";
import { FileManagerProvider } from "src/providers/file-manager/file-manager";
import { WebSurveyProvider } from "src/providers/web-service/webservice-survey";
import { SurveyDisplayComponent } from "./survey-display/survey-display.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { TranslationProvider } from "src/providers/translation/translation";
import { SurveyBmiComponent } from "./survey-bmi/survey-bmi.component";
import { FormsModule } from "@angular/forms";
import { SurveyButtonMultiComponent } from "./survey-button-multi/survey-button-multi.component";
import { EnvServiceProvider } from "../providers/environment/environment-settings";
import { environment } from "src/environments/environment";
import { LoggerModule, NGXLogger } from "ngx-logger";
import { SurveyEngagementCardComponent } from "./survey-engagement-card/survey-engagement-card.component";
import { OnboardingComponent } from "./onboarding/onboarding.component";
import { SurveyDialogComponent } from "./survey-dialog/survey-dialog.component";
import { SurveyBaseComponent } from "./survey-base/survey-base.component";

@NgModule({
  declarations: [
    AppComponent,
    SurveyImageComponent,
    SurveyButtonComponent,
    SurveyDisplayComponent,
    PageNotFoundComponent,
    SurveyBmiComponent,
    SurveyButtonMultiComponent,
    SurveyEngagementCardComponent,
    SurveyDialogComponent,
    SurveyButtonMultiComponent,
    OnboardingComponent,
    SurveyBaseComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    HttpModule,
    LinkyModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    }),
    // The following is the configuration for the ngx-logger module
    // used for application logging purposes.
    //
    // NOTE: There is some incompatibility between the version of angular
    //       we're currently using (e.g  10) and the ngx-logger module
    //       version 5. Therefore, our package.json is using explicitly
    //       ngx-logger 4.3.3.
    LoggerModule.forRoot({
      serverLoggingUrl: environment.apiUrl,
      level: environment.logLevel,
      serverLogLevel: environment.serverLogLevel,
      disableConsoleLogging: environment.disableConsoleLogging
    })
  ],
  providers: [
    FileManagerProvider,
    WebSurveyProvider,
    TranslationProvider,
    EnvServiceProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private logger: NGXLogger) {

    const welcomeMessage = 'Welcome to the Mobile Questions UI (a.k.a MQUI). '
      + 'Using environment profile[' + environment.name + '].';

    this.logger.info(welcomeMessage);
  }
}
